const counters = document.querySelectorAll('.stats__number');
const countersContainer = document.querySelectorAll('.stats');

if (countersContainer) {
  const updateCount = (counter, target) => {
    const duration = 2000;
    const startTime = performance.now();

    const step = (currentTime) => {
      const elapsedTime = currentTime - startTime;
      const progress = Math.min(elapsedTime / duration, 1);
      const value = Math.max(0, Math.floor(progress * target));

      counter.textContent = value;

      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        counter.textContent = target;
      }
    };

    counter.textContent = "0";
    requestAnimationFrame(step);
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const counter = entry.target;
      const target = +counter.getAttribute("data-target");

      if (entry.isIntersecting) {
        updateCount(counter, target);
      } else {
        counter.textContent = "0";
      }
    });
  }, { threshold: 0.5 });

  counters.forEach(counter => observer.observe(counter));
}